module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_3_2.6075f4d0.png";